'use client';

import './styles/@theme';
import { FavoritesButton } from '@/app/elements/favorites-button/favorites-button';

type GameDetailsProps = {
    uid: string;
    name: string;
    description: string;
    hasFavouriteButton?: boolean;
};

export const GameDetails = ({ uid, name, description, hasFavouriteButton = true }: GameDetailsProps) => {
    return (
        <div className="game-details">
            <div>
                <div className="game-details__name">{name}</div>
                <div className="game-details__description">{description}</div>
            </div>

            {hasFavouriteButton && <FavoritesButton uid={uid} />}
        </div>
    );
};
